export const uniqBy = <T, K>(array: T[], iteratee: (item: T) => K): T[] => {
    const result: T[] = [];
    const seen = new Set<K>();

    for (const element of array) {
        const value = iteratee(element);

        if (!seen.has(value)) {
            result.push(element);
            seen.add(value);
        }
    }

    return result;
};
export const uniqBy = <T, K>(array: T[], iteratee: (item: T) => K): T[] => {
    const result: T[] = [];
    const seen = new Set<K>();

    for (const element of array) {
        const value = iteratee(element);

        if (!seen.has(value)) {
            result.push(element);
            seen.add(value);
        }
    }

    return result;
};
